import React from "react";

class EventCard extends React.Component {
  state = {
    open: false
  };

  onToggleTextBlock = () => {
    this.setState(state => ({
      open: !state.open
    }));
  };

  addStroke = text => {
    return {
      __dangerousHTML: `${text.replace(
        /(ул.|д.|м.|стр.|корп.) /gi,
        "$1&nbsp;"
      )}`
    };
  };

  getItemStyle = item => {
    if (item.event_type === "partner" && item.type !== "Спецпредложение")
      return { backgroundColor: "rgba(153, 204, 204, 0.3)" };
    if (item.type === "Спецпредложение") return { backgroundColor: "#F9EED2" };
  };

  render() {
    const { item, clientWidth, isViewMap, resetMapEventsData } = this.props;
    const { open } = this.state;
    return (
      <div
        className="card"
        style={{
          ...this.getItemStyle(item),
          gridTemplateColumns: isViewMap ? "1fr 350px" : null
        }}
      >
        <div className="left-block">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            {item.library_id && (
              <a
                href={"http://bibliogorod.ru/libraries/" + item.library_id}
                target="_blank"
                rel="noopener noreferrer"
              >
                {item.library_name}
              </a>
            )}
            {item.partner_name && (
              <a href={item.website} target="_blank" rel="noopener noreferrer">
                {item.partner_name}
              </a>
            )}
            <p>
              <nobr>{item.minimal_age}+</nobr>
            </p>
          </div>
          <div className="afisha__card-date">
            <p>{item.date}</p>
            <p>
              {item.time_start}–{item.time_finish}
            </p>
          </div>
          {clientWidth && <Type type={item.type} />}
          <p style={{ fontWeight: "bold" }}>{item.title}</p>
          <div className="description">
            <p>{item.announce}</p>
            {open && <p style={{ marginTop: "10px" }}>{item.text}</p>}
          </div>
          {item.text && (
            <div style={buttonContainer}>
              <button
                style={buttonStyle}
                onClick={() => this.onToggleTextBlock()}
              >
                {open ? "Свернуть" : "Подробно"}
              </button>
              <svg
                style={
                  open
                    ? { ...arrowStyle, transform: "rotate(-90deg)" }
                    : arrowStyle
                }
                width="7"
                height="10"
                viewBox="0 0 7 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M1.5 10L0 8.5L3.5 5L0 1.5L1.5 0L6.5 5L1.5 10Z"
                  fill="#808080"
                />
              </svg>
            </div>
          )}
          {!clientWidth && <Type type={item.type} />}
        </div>
        <div className="right-block">
          <div
            style={
              isViewMap
                ? { display: "flex", justifyContent: "space-between" }
                : null
            }
          >
            <div>
              {item.address && (
                <p dangerouslySetInnerHTML={{ __html: item.address }} />
              )}
              {item.metro && <p>м. {item.metro}</p>}
              {item.region && <p>{item.region}</p>}
              {item.district && <p>{item.district}</p>}
              {item.phone && (
                <p dangerouslySetInnerHTML={{ __html: item.phone }} />
              )}
            </div>
            {isViewMap && (
              <svg
                onClick={() => resetMapEventsData()}
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18.0173 10.9463L15.0711 13.8925L12.1248 10.9463L10.9463 12.1248L13.8926 15.071L10.9463 18.0173L12.1248 19.1958L15.0711 16.2496L18.0173 19.1958L19.1959 18.0173L16.2496 15.071L19.1959 12.1248L18.0173 10.9463Z"
                  fill="#2B2B2B"
                />
                <rect
                  x="1"
                  y="1"
                  width="28"
                  height="28"
                  rx="4"
                  stroke="#E9E9F0"
                  strokeWidth="2"
                />
              </svg>
            )}
          </div>
          {item.registration_url && (
            <a
              href={item.registration_url}
              target="_blanck"
              rel="noopener noreferrer"
            >
              <button>Регистрация</button>
            </a>
          )}
        </div>
      </div>
    );
  }
}

export default EventCard;

const Type = ({ type }) => {
  return (
    <p
      style={{
        fontSize: "14px",
        color: "#808080"
      }}
    >
      {type}
    </p>
  );
};

const buttonContainer = {
  marginBottom: "20px",
  display: "flex",
  alignItems: "center"
};

const buttonStyle = {
  border: "none",
  padding: "0 0 2px 0",

  lineHeight: "normal",
  fontSize: "14px",

  color: "#808080",

  boxShadow: "none"
};

const arrowStyle = {
  marginLeft: "5px",
  transform: "rotate(90deg)"
};



// WEBPACK FOOTER //
// ./src/components/Events/EventCard.js